export default __webpack_public_path__ + "static/Денежный поток 4-27183c4ea9c8f5e1c7f415786d8e77a6.jpg";